// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__2KQxD","choiceBoxes":"toolbarselects_choiceBoxes__2uRGX","simpleField":"toolbarselects_simpleField__1yWRK"};